var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"inter_chart",staticStyle:{"height":"20vh","width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }